import { ApiClient } from '@ifixit/carpenter-utils';

export const apiClient = new ApiClient();
